import Badge from 'src/components/badges/badge';

type BadgesProps = {
  className?: string,
  roles: string[],
  showOne?: boolean,
  type?: string,
}

const Badges = ({
  className,
  roles = [],
  showOne = true,
  type = 'member',
}: BadgesProps) => {

  if (roles.length === 0) return null;

  let rolesToDisplay = roles;

  if (showOne) {
    rolesToDisplay = [roles[0]];
  }

  return (
    <span className={className} title={roles.join(', ')}>
      {rolesToDisplay.map(role =>
        <Badge content={role} key={role}
          type={type} />,
      )}
    </span>
  );
};

export default Badges;
